import {lazyRegister} from '@/Core/lazyRegister';
import {
    UserModel
} from "@/models";
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class SessionInfoService {
    static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }


    getInfo() {
        return this.baseApiFactory.getData<UserModel>('/v2/api/session/info');
    };
}

lazyRegister.service('SessionInfoService', SessionInfoService);
